import React from 'react';
import './Contact.css';
import contactImg from '../assets/images/c.jpg';

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h1 className="section-title">Contact Me</h1>
        <div className="contact-content">
          <img src={contactImg} alt="Contact" className="contact-image" />
          <div className="contact-info">
            <ul>
              <li>
                <a href="https://github.com/nimishathallapally" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-github"></i> GitHub Profile
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/nimisha-thallapally-b156a1261" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-linkedin"></i> LinkedIn Profile
                </a>
              </li>
              <li>
                <a href="mailto:nimishathallapally@gmail.com">
                  <i className="fa-solid fa-envelope"></i> nimishathallapally@gmail.com
                </a>
              </li>
            </ul>
            <div className="resume">
              <a href={`${process.env.PUBLIC_URL}/doc/Resume_Nimisha.pdf`} download="Resume_Nimisha.pdf" className="down-btn">
                Download Resume
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
